// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueCharts from 'vue-chartjs'
import firebase from "firebase";
import VueGtag from "vue-gtag";
import VueMeta from "vue-meta";

Vue.config.productionTip = false

// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBDluR2gzFdv-krNXUTtSiZ5oh3wUTWGao",
  authDomain: "choosecomputer-d9ca8.firebaseapp.com",
  databaseURL: "https://choosecomputer-d9ca8.firebaseio.com",
  projectId: "choosecomputer-d9ca8",
  storageBucket: "choosecomputer-d9ca8.appspot.com",
  messagingSenderId: "437015821281",
  appId: "1:437015821281:web:6d7ebfb17a1eeaee3970a0",
  measurementId: "G-Y9VBMRKHTS"
};
firebase.initializeApp(firebaseConfig);

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueCharts)
Vue.use(VueGtag, {
  config: { id: "G-ER5DKNFKNR" }
});
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js